import { toast } from 'sonner';
import { getErrorMessage } from '@/lib/errors/get-error-message';

type ToastErrorOptions = Parameters<typeof toast.error>[1];

interface ToastErrorParameters {
  error: unknown;
  options?: ToastErrorOptions;
  title: string;
}

/**
 * Displays a toast with a stable title and (when available) a detailed
 * description resolved from the provided error. The resolved message is
 * returned so callers can reuse it for logging.
 */
export function toastError({ error, title, options }: ToastErrorParameters): string {
  const message = getErrorMessage(error, title);
  let description = options?.description;
  if (description === undefined) {
    description = message === title ? undefined : message;
  }

  toast.error(title, {
    ...options,
    description,
  });

  return message;
}
